import { ComplexSuggestedItem } from '../../../ui/gzComplexEnumList/types';

export enum RemoteDetailsTypes {
  IncidentsEntities = 1,
  IncidentsResources,
  VulnerabilitiesName,
  VulnerabilitiesCve,
  MisconfigurationsRegions,
  MisconfigurationsAffectedDevices,
  VulnerabilitiesAffectedDevices,
  UserBehaviorRisksAffectedUsers,
  UserBehaviorRisksRegions,
  MisconfigurationsNames,
  HumanBasedRisksNames,
  RiskManagementUsername,
  DevicesNames,
  DevicesRegions,
  RiskManagementUsersDepartments,
  RiskManagementUsersDevices,
  DevicesFqdn,
  DevicesMacs,
  DevicesCves,
  DevicesIp,
  EASMAssetsName,
  DevicesResourceId,
  UsersRegions,
  UsersResourceId,
  IncidentsActors,
  PhasrBehavioralProfileIdentities,
  PhasrBehavioralProfileIdentitiesForRules,
  PhasrBehavioralProfileResources,
  PhasrBehavioralProfileResourcesForRules,
  PhasrRecommendationName,
  PhasrMonitoredRuleName,
  EASMArtifactsName,
  EASMArtifactsCVEs,
  EASMArtifactsRelatedAssets,
  EASMAssetsRelatedAssets,
  EASMAssetsRelatedArtifacts,
  MainResourceNames,
  DevicesCloudAccountIds,
  DevicesImageRepos,
  DevicesRegistryHosts,
  DevicesClusterNames,
  BreachPathResourceNames,
  BreachPathCloudAccountIds,
}

export interface ResponseDetails {
  hasErrors: boolean;
  requestIsDeprecated: boolean;
  response: ComplexSuggestedItem[];
}
